// extracted by mini-css-extract-plugin
export default {"content":"page_content__fNTp3","error":"page_error__9iOw8"};